import React, { useState, useContext } from "react";

// import lazulitop from "../../image/flirty-lazuli/lauzlitop.webp";

import { CartContext } from "../../CartContext";
import Footer from "../../components/footer/Footer";
import BackToCollection from "../../components/item/BackToCollection";
import ItemDetailCopy from "../../components/item/ItemDetailCopy";
import "../../project_samples/Projects.css";

const Shop = ({ items, backTo, backLabel }) => {
  const { addToCart } = useContext(CartContext);
  const [selectedImage, setSelectedImage] = useState({});
  const [selectedSize, setSelectedSize] = useState(null);

  const selectThumbnail = (itemId, image) => {
    setSelectedImage((prevSelectedImage) => ({
      ...prevSelectedImage,
      [itemId]: image,
    }));
  };

  const getDisplayImage = (item) =>
    selectedImage[item.id] ||
    (Array.isArray(item.image) ? item.image[0] : item.image);

  return (
    <main className="item-page">
      <BackToCollection to={backTo} label={backLabel} />
      <section className="item-list" aria-label="Product details">
        {items.map((item) => (
          <article className="item-detail-card" key={item.id}>
            <form className="item-detail-shell item-detail-shell--standard">
              <div className="item-purchase-panel">
                <p className="item-eyebrow">You Are Art</p>
                <h1 className="item-title">{item.name}</h1>

                <div
                  className="item-thumbnail-grid"
                  aria-label="Product images"
                >
                  {item.thumbnails.map((thumbnail, index) => {
                    const isSelected = getDisplayImage(item) === thumbnail;

                    return (
                      <button
                        type="button"
                        className={`item-thumbnail ${
                          isSelected ? "item-thumbnail--active" : ""
                        }`}
                        key={`${thumbnail}-${index}`}
                        aria-label={`View ${item.name} image ${index + 1}`}
                        aria-pressed={isSelected}
                        onClick={() => selectThumbnail(item.id, thumbnail)}
                      >
                        <img src={thumbnail} height={90} width={90} alt="" />
                      </button>
                    );
                  })}
                </div>
              </div>

              <div className="item-main-image-frame">
                <img
                  src={getDisplayImage(item)}
                  height={760}
                  width={620}
                  alt={item.name}
                  className="item-main-image"
                />
              </div>

              <div className="item-detail-aside">
                <ItemDetailCopy description={item.description} />

                <div className="item-action-panel">
                  <fieldset className="item-size-group">
                    <legend className="item-size-label">SIZE</legend>
                    <div className="item-size-options">
                      {item.sizes.map((size) => (
                        <label className="item-size-option" key={size}>
                          <input
                            type="radio"
                            name={`size-${item.id}`}
                            value={size}
                            checked={selectedSize === size}
                            onChange={() => setSelectedSize(size)}
                          />
                          <span>
                            {size.charAt(0).toUpperCase() + size.slice(1)}
                          </span>
                        </label>
                      ))}
                    </div>
                  </fieldset>

                  <button
                    className="item-add-button"
                    disabled={!selectedSize}
                    type="button"
                    onClick={() => {
                      addToCart(item, selectedSize);
                    }}
                  >
                    ADD TO CART
                  </button>
                </div>
              </div>
            </form>
          </article>
        ))}
      </section>

      <Footer />
    </main>
  );
};

export default Shop;
